import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminTradesInstancesRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/trades/instances',
  validateSearch: z.object({
    page: zodPage,
    query: z.string().optional(),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/admin/TradesInstances/AdminTradesInstancesPage/AdminTradesInstancesPage').then(
    (d) => d.Route
  )
);
